import React, { Fragment, useEffect, useState, forwardRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { translate } from '../../../../Services/translation';
import { NavLink } from 'react-router-dom';
import { post, get } from '../../../../Services/http';
import { BACKEND_LOGGEND_IN_SHOPID } from '../../../Services/Api.service';
import * as debounce from 'lodash.debounce';
import { isEcomAdmin } from '../../../Services/Api.service';
import DatePicker from "react-datepicker";
import Pagination from '../../../../Components/Pagination';
import { calculatePager } from '../../../../Services/Pagination.service';

const OrderList = () => {
    let initialAvailableDate = {
        mindate: new Date(),
        maxdate: new Date()
    }    

    const [orders, setorders] = useState([]);
    const [totalOrderCount, settotalOrderCount] = useState();
    const [searchText, setsearchText] = useState('');
    const [statuses, setstatuses] = useState([]);
    const [selectedStatuses, setselectedStatuses] = useState([]);    
    const [availableDates, setavailableDates] = useState(initialAvailableDate);
    const [endAvailableDates, setendAvailableDates] = useState(initialAvailableDate);
    const [startDate, setstartDate] = useState('');
    const [startDateFormatted, setstartDateFormatted] = useState('');
    const [endDate, setendDate] = useState('');
    const [endDateFormatted, setendDateFormatted] = useState('');
    const [showStatusFilterOptions, setshowStatusFilterOptions] = useState(false);
    const [showDateFilterOptions, setshowDateFilterOptions] = useState(false);
    const [storeIds, setStoreIds] = useState([]);
    const [showStoreFilterOptions, setshowStoreFilterOptions] = useState(false);
    const [selectedStoreIds, setselectedStoreIds] = useState([]); 
    const [pager, setPager] = useState({});
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);    
    const [dateFilterReset, setdateFilterReset] = useState(false);
    const [storeIdsAndNames, setstoreIdsAndNames] = useState([]);
    const [loading, setloading] = useState(false);


    useEffect(() => {        
        const currentFullDate = new Date();
        const availableFullDate = new Date(currentFullDate.getFullYear() - 10, currentFullDate.getMonth(), currentFullDate.getDate());
        setavailableDates({mindate: availableFullDate, maxdate: currentFullDate});   
        setendAvailableDates({mindate: availableFullDate, maxdate: currentFullDate});   
                
        let tempCurrentDateStart = new Date();
        tempCurrentDateStart.setMonth(tempCurrentDateStart.getMonth() - 5);
        let tempCurrentDateEnd = new Date();
        tempCurrentDateEnd.setMonth(tempCurrentDateEnd.getMonth());

        setendDate(tempCurrentDateEnd);
        setstartDate(tempCurrentDateStart);
        
        get('api/ordersearch/getallstoreidsandstatus')
        .then((response) => response.json())
        .then((result) =>  {             
            if (isEcomAdmin() && result.storeIds) {
                setstoreIdsAndNames(result.storeIds);
                const storeIdList = result.storeIds.map(x => x.key);
                setStoreIds(storeIdList);
                queryOrders(storeIdList, getDateFormatted(tempCurrentDateStart), getDateFormatted(tempCurrentDateEnd));                 
            } else {
                queryOrders(null, getDateFormatted(tempCurrentDateStart), getDateFormatted(tempCurrentDateEnd)); 
            }                   
            setstatuses(result.statuses);
        });        
    }, []);

    useEffect(() => {
        if (startDate) {
            const dateValue = new Date(startDate); 
            setstartDateFormatted(getDateFormatted(startDate)); 
            
            const availableFullDate = new Date(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate());
            setendAvailableDates({mindate: availableFullDate, maxdate: new Date()}); 
            setendDate('');
            setendDateFormatted('');
        }                     
    }, [startDate]); 

    useEffect(() => {
        if (endDate) {
           setendDateFormatted(getDateFormatted(endDate));                          
        }                     
    }, [endDate]);

    const getDateFormatted = (date) => {
        const dateValue = new Date(date); 
        const formattedDateEndDate = `${String(dateValue.getDate()).padStart(2, '0')}-${String(dateValue.getMonth() + 1).padStart(2, '0')}-${dateValue.getFullYear()}`;          
        return formattedDateEndDate;
    }

    const queryOrders = (storeIdsInitial, startDateInitial, endDateInitial) => {
        setloading(true);
        post('api/ordersearch/getordersforsalesmodule', {
            opticianId: isEcomAdmin() ? "" : localStorage.getItem(BACKEND_LOGGEND_IN_SHOPID),
            startDate: startDateInitial ? startDateInitial : startDateFormatted,
            endDate: endDateInitial ? endDateInitial : endDateFormatted,
            orderStatus: selectedStatuses,
            pageIndex: currentPage > 0 ? currentPage : 1, 
            pageSize: pageSize,
            searchText: searchText,
            isAdmin: isEcomAdmin(),
            storeIds: storeIdsInitial ? storeIdsInitial : selectedStoreIds,
        })
        .then((response) => response.json())
        .then((result) => {
            setorders(result.orders);
            settotalOrderCount(result.totalCount);  
            setloading(false);
        });
    }

    useEffect(() => {
        if (dateFilterReset) {
            queryOrders();                     
        }                     
    }, [dateFilterReset]);

    const debouncedQuery = debounce((text) => queryOrders());

    const onSearch = (text) => {  
        setsearchText(text);                
    }
    
    const loadSearch = () => {
        if (searchText.length > 2) {
            debouncedQuery(searchText);
        }
    }

    const  addOrRemoveSelectedStoreIds  = (event) => {
        const tempSelectedStoreIds = selectedStoreIds;
        const index = tempSelectedStoreIds ? selectedStoreIds.indexOf(event.target.value) : -1;
        if (index > -1) {            
            tempSelectedStoreIds.splice(index, 1);
            event.target.checked = false;
        } else {
            tempSelectedStoreIds.push(event.target.value);
            event.target.checked = true;
        }
        setselectedStoreIds(tempSelectedStoreIds);        
    }

    const addOrRemoveSelectedStatus = (event) => {
        const tempSelectedStatus = selectedStatuses;
        const index = tempSelectedStatus ? selectedStatuses.indexOf(event.target.value) : -1;
        if (index > -1) {            
            tempSelectedStatus.splice(index, 1);
            event.target.checked = false;
        } else {
            tempSelectedStatus.push(event.target.value);
            event.target.checked = true;
        }
        setselectedStatuses(tempSelectedStatus);        
    }

    const DatePickerInputStart = forwardRef((data, ref) => {
        const [readOnly, setReadOnly] = useState(false);
        return (
            <div className='completedorderexport__datepicker' onClick={data.onClick} ref={ref} >
                <input className="register__datepicker-input" placeholder={data.placeholder} autoComplete="off" value={startDateFormatted} onChange={data.onChange}
                        onFocus={() => setReadOnly((window.innerWidth <= 760))}
                        onBlur={() => setReadOnly(false)}
                        readOnly={readOnly} />
                <div className="register__datepicker-icon" />
            </div>
        );
    });

    const DatePickerInputEnd = forwardRef((data, ref) => {
        const [readOnly, setReadOnly] = useState(false);
        return (
            <div className='completedorderexport__datepicker' onClick={data.onClick} ref={ref} >
                <input className="register__datepicker-input" placeholder={data.placeholder} autoComplete="off" value={endDateFormatted} onChange={data.onChange}
                        onFocus={() => setReadOnly((window.innerWidth <= 760))}
                        onBlur={() => setReadOnly(false)}
                        readOnly={readOnly} />
                <div className="register__datepicker-icon" />
            </div>
        );
    }); 

    const resetStatusFilter = () => {
        document.querySelectorAll(".statuscheckbox").forEach(elem => {
            elem.checked = false;
        });
        setselectedStatuses([]);
        queryOrders();
    }

    const resetDateFilter = () => {
        setstartDate('');
        setendDate('');
        setstartDateFormatted('');
        setendDateFormatted('');        
        setshowDateFilterOptions(false);
        setdateFilterReset(true);
    }

    const resetStoreIdFilter = () => {
        document.querySelectorAll(".storecheckbox").forEach(elem => {
            elem.checked = false;
        });
        setselectedStoreIds([]);        
    }  

    useEffect(() => {   
        if (currentPage !== 0 ) {
            queryOrders();
        }        
    }, [currentPage])

    useEffect(() => {
        setPager(calculatePager(totalOrderCount, currentPage > 0 ? currentPage : 1, {pageSize: pageSize}));
    }, [totalOrderCount, currentPage, pageSize]);

    const changePageIndex = useCallback(
        (pageIndex) => {
            if (pageIndex !== currentPage) {
                setCurrentPage(pageIndex);                
            }
        },
        [currentPage, dispatch]
    );

    return (
        <Fragment>
            <div className='admin-portal__sales-module'>
                <div className='go-back-wrapper'>
                    <NavLink to="/ecommercelanding" className='go-back-button'>{translate('coptikk.adminportal.customer.backbutton')}</NavLink>
                </div>
                <h1 className='title'>{translate("coptikk.adminportal.sales.title")}</h1>
                <div className='search-and-filters'>
                    <div className='search-wrapper'>
                        <div className="quick-search" role="search">
                            <div className={`quick-search__form quick-search__form--force-show`} role="search">
                                <input className="quick-search__input" type="search" placeholder={translate("coptikk.adminportal.sales.search")}
                                    autoComplete="off" value={searchText} onChange={event => onSearch(event.target.value)} 
                                    onKeyPress={(e) => {e.key === 'Enter' ? queryOrders() : ""}}                    
                                />
                                <i className="quick-search__icon" onClick={() => queryOrders()}></i>
                            </div>
                        </div>
                    </div>
                    <div className='filter-wrapper'>
                        <p className='description'>{translate("coptikk.adminportal.sales.filter")}:</p>
                        <div>
                            <div className='filter' onClick={() =>  setshowStatusFilterOptions(!showStatusFilterOptions)}>
                                <p>{translate("coptikk.adminportal.sales.filter.status")} {selectedStatuses && selectedStatuses.length > 0 ? `(${selectedStatuses.length})` : ""}</p>
                            </div>
                            {showStatusFilterOptions && <div className="drop-down">
                                {statuses.map((status) => {
                                    return <div className='item' value={status} onClick={(e) => addOrRemoveSelectedStatus(e)}>
                                         {selectedStatuses && selectedStatuses.indexOf(status) > -1 ? 
                                            <input type='checkbox' className='statuscheckbox' checked value={status}></input>
                                         : <input type='checkbox' className='statuscheckbox' value={status}></input>}
                                        {status}
                                    </div>
                                })}
                                <div className="save-button button" onClick={() => { queryOrders(); setshowStatusFilterOptions(false);}}>{translate('coptikk.adminportal.sales.filtersearchtext')}</div>
                                <div className="clear-button" onClick={() => resetStatusFilter()}>{translate('coptikk.adminportal.sales.filtersearchclear')}</div>
                            </div>}
                        </div>                        
                        <div>
                            <div className='filter' onClick={() => setshowDateFilterOptions(!showDateFilterOptions)}>
                                <p>{translate("coptikk.adminportal.sales.filter.date")}</p>
                            </div>
                            {showDateFilterOptions && <div className="drop-down date">
                                <p className='date-title'>{translate("coptikk.adminportal.sales.date.description")}</p>
                                <div className='item__date'>
                                    {window.innerWidth <= 760 ?
                                        <DatePicker
                                            dateFormat="dd-MM-yyyy"
                                            placeholderText={translate("coptikk.adminportal.sales.date.from")}
                                            locale="nb"
                                            minDate={availableDates.mindate}
                                            maxDate={availableDates.maxdate}
                                            onChange={(date) => setstartDate(date)}
                                            popperClassName="booking"
                                            customInput={<DatePickerInputStart />}
                                        /> : <DatePicker
                                            dateFormat="dd-MM-yyyy"
                                            placeholderText={translate("coptikk.adminportal.sales.date.from")}
                                            locale="nb"
                                            minDate={availableDates.mindate}
                                            maxDate={availableDates.maxdate}
                                            onChange={(date) => setstartDate(date)}
                                            customInput={<DatePickerInputStart />}
                                        />}
                                </div>
                                <div className='item__date'>
                                    {window.innerWidth <= 760 ?
                                        <DatePicker
                                            dateFormat="dd-MM-yyyy"
                                            placeholderText={translate("coptikk.adminportal.sales.date.to")}
                                            locale="nb"
                                            minDate={endAvailableDates.mindate}
                                            maxDate={endAvailableDates.maxdate}
                                            onChange={(date) => setendDate(date)}
                                            popperClassName="booking"
                                            customInput={<DatePickerInputEnd />}
                                        /> : <DatePicker
                                            dateFormat="dd-MM-yyyy"
                                            placeholderText={translate("coptikk.adminportal.sales.date.to")}
                                            locale="nb"
                                            minDate={endAvailableDates.mindate}
                                            maxDate={endAvailableDates.maxdate}
                                            onChange={(date) => setendDate(date)}
                                            customInput={<DatePickerInputEnd />}
                                        />}
                                </div>
                                <div className="save-button button" onClick={() => { queryOrders(); setshowDateFilterOptions(false); }}>{translate('coptikk.adminportal.sales.filtersearchtext')}</div>
                                <div className="clear-button" onClick={() => resetDateFilter() }>{translate('coptikk.adminportal.sales.filtersearchclear')}</div>
                            </div>}
                        </div> 
                        {isEcomAdmin() && <div>
                            <div className='filter' onClick={() => setshowStoreFilterOptions(!showStoreFilterOptions)}>
                                <p>{translate("coptikk.adminportal.sales.opticians")} {selectedStoreIds && selectedStoreIds.length > 0 ? `(${selectedStoreIds.length})` : ""}</p>
                            </div>
                            {showStoreFilterOptions && <div className="drop-down">
                                {storeIdsAndNames.map((storeId) => {
                                    return storeId && 
                                    <div className='item' value={storeId.key} onClick={(e) => addOrRemoveSelectedStoreIds(e)}>
                                        {selectedStoreIds && selectedStoreIds.indexOf(storeId.key) > -1 ? 
                                            <input type='checkbox' className='storecheckbox' checked value={storeId.key}></input> 
                                        : <input type='checkbox' className='storecheckbox' value={storeId.key}></input>} 
                                        {storeId.value}{" "}{storeId.key}
                                    </div>
                                })}
                                <div className="save-button button" onClick={() => { setdateFilterReset(false); queryOrders(); setshowStoreFilterOptions(false);}}>{translate('coptikk.adminportal.sales.filtersearchtext')}</div>
                                <div className="clear-button" onClick={() => resetStoreIdFilter()}>{translate('coptikk.adminportal.sales.filtersearchclear')}</div>
                            </div>}
                        </div>}
                    </div>
                </div>
                <div className='order-list'>
                    <div className="order-list__header-row">
                        <div className="columns medium-1 header-item">
                            {translate('coptikk.adminportal.order.flag')}
                        </div>
                        <div className="columns medium-2 header-item">
                            {translate('coptikk.adminportal.order.ordernumber')}
                        </div>
                        <div className="columns medium-2 header-item">
                            {translate('coptikk.adminportal.order.date')}
                        </div>
                        <div className="columns medium-1 header-item">
                            {translate('coptikk.adminportal.order.status')}
                        </div>   
                        <div className="columns medium-2 header-item">
                            {translate('coptikk.adminportal.order.comment')}
                        </div>    
                        <div className="columns medium-2 header-item">
                            {translate("coptikk.adminportal.sales.ordertype")}
                        </div> 
                        <div className="columns medium-2 header-item"></div>                    
                    </div>     
                    {loading &&
                        <div className='overlay'>
                            <div className='loading-spinner'></div>
                        </div>             
                    }         
                    {!loading && orders && orders.map(item => {
                        return <div className='order-list__order-row'>
                            <div className="columns medium-1 order-item">
                                <p className='show-for-small'>{translate('coptikk.adminportal.order.flag')}: </p>
                                {item.orderDelayedFlag && <div className='flag-icon'></div>}                                
                                {item.orderNotSentFlag && <div className='flag-icon-red'></div>}   
                                {item.sentToCustomerDelayFlag && <div className='flag-icon-orange'></div>}  
                            </div>
                            <div className="columns medium-2 order-item">
                                <p className='show-for-small'>{translate('coptikk.adminportal.order.ordernumber')}: </p>
                                {item.orderNumber}                                
                            </div>
                            <div className="columns medium-2 order-item">
                                <p className='show-for-small'>{translate('coptikk.adminportal.order.date')}: </p>
                                {item.orderDate}                                
                            </div>
                            <div className="columns medium-1 order-item">
                                <p className='show-for-small'>{translate('coptikk.adminportal.order.status')}: </p>
                                {item.orderStatus}                                
                            </div>
                            <div className="columns medium-2 order-item comment">
                                <p className='show-for-small'>{translate('coptikk.adminportal.order.comment')}: </p>
                                {item.commentsInfo ? item.commentsInfo.comments : ""}
                            </div>
                            <div className="columns medium-2 order-item">
                                <p className='show-for-small'>{translate('coptikk.adminportal.sales.ordertype')}: </p>
                                {item.isSubscriptionOrder ? translate("coptikk.product.subscription") : translate("coptikk.product.onlyonetimeshop")}
                            </div>
                            <div className="columns medium-2 order-item">
                                <NavLink to={"/orderdetail?orderId=" + item.orderSystemId} className='button'>{translate('coptikk.adminportal.order.gotoorder')}</NavLink>
                            </div>
                        </div>
                    })}
                    
                </div>
                <Pagination model={pager} onChange={changePageIndex} />
            </div>
        </Fragment>
    )

}

export default OrderList;